import React, { useState } from 'react';
import { Calendar } from 'lucide-react';

export default function BookCallButton() {
  const [isHovered, setIsHovered] = useState(false);

  const calendlyUrl = process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/myeai-info/30min';

  return (
    <div className="fixed bottom-5 left-5 z-50" data-testid="book-call-button">
      {/* Tooltip */}
      <div
        className={`absolute bottom-full left-0 mb-2 transition-all duration-300 ${
          isHovered ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-2 pointer-events-none'
        }`}
      >
        <div className="bg-[#162959] text-white text-sm px-4 py-2 rounded-lg shadow-lg whitespace-nowrap">
          Want Personalized Guidance? Book a Free Discovery Call
          <div className="absolute -bottom-1 left-4 w-2 h-2 bg-[#162959] transform rotate-45"></div>
        </div>
      </div>

      {/* Button */}
      <a
        href={calendlyUrl}
        target="_blank"
        rel="noopener noreferrer"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="flex items-center justify-center w-14 h-14 bg-[#337AF7] text-white rounded-full shadow-lg hover:bg-[#2563eb] hover:shadow-xl hover:scale-110 transition-all duration-300"
        aria-label="Book a Discovery Call"
        data-testid="book-call-link"
      >
        <Calendar className="h-6 w-6" />
      </a>
    </div>
  );
}
